import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';
import { EMPTY_ID } from '@e-socna/empty-client';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const MissionQuotationStateForm_MissionQuotation_ActionPermissions_QueryDocument =
  graphql(`
    query MissionQuotationStateForm_MissionQuotation_ActionPermissions_Query(
      $id: Id!
    ) {
      findOneMission(id: $id) {
        access {
          actions(part: "quotation") {
            ...FolderBusinessEntityStateForm_ActionPermission_Fragment
          }
        }
      }
    }
  `);

export type MissionQuotationStateForm_MissionQuotation_ActionPermissions =
  ResultOf<
    typeof MissionQuotationStateForm_MissionQuotation_ActionPermissions_QueryDocument
  >['findOneMission'];

export const useFindAllMissionQuotationInfoActionPermissionsQuery = (
  id = EMPTY_ID,
  enabled = !!id,
) =>
  useGraphQLQuery(
    MissionQuotationStateForm_MissionQuotation_ActionPermissions_QueryDocument,
    { id },
    { enabled: !!id && enabled },
  );
